import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  //   TextField,
  Typography,
  Grid,
  Snackbar,
  Alert,
  AlertTitle,
} from "@mui/material";
import React, { useState } from "react";
import { useTheme } from "../../style/theme";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
// import visaImage from "../../assets/PaymentsImages/vizaa2.png"; // Update with actual path to Visa image
import Image from "../Image";
import { useLocation } from "react-router-dom";
import { useUser } from "../../hooks/Authorize";
import axios from "axios";
import loader from "../../assets/loader.gif";
import starterImg from "../../assets/startericon.png";
import privateImg from "../../assets/privateicon.png";
import businessImg from "../../assets/businessicon.png";
import enterpriseImg from "../../assets/enterpriseicon.png";
import visaImg from "../../assets/cards/visa.png";
import amexImg from "../../assets/cards/amex.png";
import dinersImg from "../../assets/cards/diners.jpg";
import discoverImg from "../../assets/cards/discover.jpg";
import jcbImg from "../../assets/cards/jcb.jpg";
import cartesImg from "../../assets/cards/cartes_bancaires.png";
import unionpayImg from "../../assets/cards/union.png";
import masterImg from "../../assets/cards/master.png";
const steps = ["Plan", "Add-Ons", "Pay", "Confirmation"];
const activeSteps = [0, 1, 2, 3]; // Dynamically set the active step (currently step 1).

const ConfirmSubscription = () => {
  const location = useLocation();
  const payload = location.state?.payload;
  const subscriptionSummary = location.state?.subscriptionSummary;
  const payloadFiles = location.state?.payloadFiles;
  const isFiles = location.state?.isFiles;
  const FreePlan = location.state?.FreePlan;
  const name = location.state?.name;
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading] = useState(false);

  console.log(FreePlan, "FreePlanFreePlan");
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page in the history stack
  };

  function getCardBrandImage(brand) {
    switch (brand?.toLowerCase()) {
      case "visa":
      case "eftpos":
        return visaImg;
      case "amex":
        return amexImg;
      case "diners":
        return dinersImg;
      case "discover":
        return discoverImg;
      case "jcb":
        return jcbImg;
      case "cartes_bancaires":
        return cartesImg;
      case "unionpay":
        return unionpayImg;
      case "mastercard":
        return masterImg;
      default:
        return visaImg;
    }
  }

  const [showMessage, setShowMessage] = useState({
    show: true,
    message: "",
    severity: "",
  });

  const { mode } = useTheme();

  const {
    plan,
    billingCycle,
    billingCycleAmount,
    nextBillingDate,
    totalAmount,
    email,
    noOfUsers,
  } = subscriptionSummary || {};

  const handleSubscribe = async () => {
    try {
      setLoading(true);

      if (isFiles && FreePlan !== "Free") {
        // Call files API first only if isFiles is true
        const fileResponse = await axios.post(
          `/store/subscription/files?userId=${platformUser._id}`,
          payloadFiles
        );

        if (fileResponse.status !== 200) {
          throw new Error("Files subscription failed");
        }
      }

      // Always call main subscription API
      const response = await axios.post(
        `/store/subscription/subscribe?userId=${platformUser._id}`,
        payload
      );

      if (response.status === 200) {
        localStorage.setItem("subscriptionId", response.data.subscriptionId);
        setShowMessage({
          show: true,
          message: "Subscribe Successfully",
          severity: "success",
        });
        //  navigate("/")
        window.location.replace("https://hr.clikkle.com/");
      }
    } catch (error) {
      console.error("Subscription Error:", error);
      setShowMessage({
        show: true,
        message: error?.response?.data?.message || "Subscription failed",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowMessage({ show: false, message: " ", severity: "" });
  };

  return (
    <Box
      sx={{
        overflow: "hidden",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Snackbar
        open={showMessage.show}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert
          severity={showMessage.severity}
          variant="filled"
          sx={{ width: "100%" }}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <AlertTitle> {showMessage.severity}</AlertTitle>
          {showMessage.message}
        </Alert>
      </Snackbar>
      <Box>
        <Button
          onClick={handleBackClick}
          sx={{
            color: mode === "light" ? "#26272C" : "#FFFFFF",
            // padding: "0.5rem 1rem",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            borderRadius: "5px",
          }}
        >
          <ArrowBackIcon sx={{ marginRight: "0.5rem" }} />
        </Button>
      </Box>

      <Box>
        {/* Header */}
        <Typography variant="h6" sx={{ color: "#A5A5A5", textAlign: "center" }}>
          Subscribe to Clikkle{" "}
          <span style={{ color: "#3B84D9", fontWeight: "bold" }}>HR</span> in 4
          Easy Steps
        </Typography>
      </Box>

      {/* Steps */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          py: 3,
          px: { xs: "2rem", sm: "5rem" },
          mb: "2rem",
        }}
      >
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 1,
                mb: "-1.5rem",
                gap: "0.6rem",
                minWidth: { xs: "70px", sm: "auto" },
              }}
            >
              <Box
                sx={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: activeSteps.includes(index)
                    ? "#407BFF"
                    : "transparent",
                  border: "1px solid gray",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: activeSteps.includes(index) ? "#fff" : "#A5A5A5",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                {index + 1}
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  color: activeSteps.includes(index) ? "black" : "#A5A5A5",
                  fontSize: { xs: "0.75rem", sm: "0.9rem" },
                  width: { xs: "60px", sm: "auto" },
                }}
              >
                {step}
              </Typography>
            </Box>
            {index < steps.length - 1 && (
              <Box
                sx={{
                  flex: 1,
                  height: "1px",
                  backgroundColor: activeSteps.includes(index)
                    ? "#407BFF"
                    : "#A5A5A5",
                  mx: { xs: "auto", sm: "10px" }, // margin X
                  my: { xs: "0.7rem", sm: 0 }, // margin Y
                  width: { xs: "60%", sm: "100%" },
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>

      <Grid
        container
        spacing={2}
        sx={{ p: 2, height: "100vh", overflow: "hidden" }}
      >
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            height: "100%",
            overflowY: "auto",
            pr: 2,
            py: 1,
            scrollbarWidth: "none", // Firefox
            "&::-webkit-scrollbar": {
              width: 0,
              height: 0,
            },
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "30px",
                fontWeight: "500",
                color: mode === "light" ? "#000" : "#FFFFFF",
                textAlign: "left",
              }}
            >
              Subscription Confirmation ✅
            </Typography>
            <Typography
              sx={{
                fontSize: "25px",
                fontWeight: "500",
                color: mode === "light" ? "#000" : "#fff",
                marginTop: "30px",
              }}
            >
              Your Information
            </Typography>
            <Typography
              sx={{ fontWeight: "400px", mt: "0.5rem", fontSize: "15px" }}
            >
              {name}
            </Typography>
            {/* <Typography
              sx={{ color: "#A5A5A5", fontSize: "15px", fontWeight: "400px" }}
            >
              313301 Kumbhalgarh Fort, Rajsamand, Rajasthan, India
            </Typography> */}
            <Typography
              sx={{
                fontSize: "25px",
                fontWeight: "500",
                color: mode === "light" ? "#000" : "#fff",
                marginTop: "30px",
              }}
            >
              Payment
            </Typography>
          </Box>

          <Box>
            <img
              src={getCardBrandImage(payload?.card?.brand)}
              alt="Visa"
              width="60"
              height="40"
            />
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: "400",
                color: mode === "light" ? "#000" : "#A5A5A5",
                // marginTop: "-4px",
              }}
            >
              visa card ending in 6262
            </Typography>
            {/* <Typography
              sx={{
                fontSize: "25px",
                fontWeight: "400",
                color: mode === "light" ? "#000" : "#fff",
                marginTop: "20px",
              }}
            >
              Billing Address
            </Typography>

            <Typography
              variant="h6"
              sx={{ color: "#FFFFFF", fontSize: "15px", marginTop: "15px" }}
            >
              BCG Technologies
            </Typography>

            <Typography
              variant="h6"
              sx={{ color: "#A5A5A5", fontSize: "12px", marginTop: "1px" }}
            >
              14thA Cross, Garden Layout, JP Nagar 7th Phase
            </Typography>
            <Typography
              variant="h6"
              sx={{ color: "#A5A5A5", fontSize: "12px" }}
            >
              Mumbai, India
            </Typography> */}
          </Box>
          <Box>
            <Button
              sx={{
                backgroundColor: "#3767B1",
                color: "#FFFFFF",
                fontSize: "16px",
                padding: "12px 20px",
                borderRadius: "5px",
                marginTop: "20px",
                width: "100%",
                textAlign: "center",
                "&:hover": {
                  backgroundColor: "#2E6FC6",
                },
              }}
              onClick={handleSubscribe}
            >
              {loading ? (
                <img alt="loading..." src={loader} width={15} />
              ) : (
                "Pay Now"
              )}
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={4} sx={{ height: "100%", overflow: "hidden" }}>
          {/* Subscriptions Summary card */}
          <Box
            sx={{
              position: "relative",
              borderRadius: "10px",
              overflow: "hidden",
              p: "2px", // for visible gradient border thickness
              background: "linear-gradient(45deg, #6A0B61, #3767B1)",
            }}
          >
            <Card
              sx={{
                borderRadius: "inherit",
                backgroundColor: mode === "light" ? "white" : "black",
                width: "100%",
                height: "100%",
                padding: 1,
              }}
            >
              <CardContent>
                {/* Subscription Summary Header */}
                <Typography
                  variant="h6"
                  sx={{
                    color: mode === "light" ? "black" : "#FFFFFF",
                    borderBottom: "1px solid #5C5C5C",
                    pb: 1,
                    mb: 2,
                  }}
                >
                  Subscription Summary
                </Typography>

                {/* Enterprise Section */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={3}
                >
                  <Box display="flex" alignItems="center">
                    <Box
                      sx={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: `1px solid ${
                          mode === "light" ? "#d1d5db" : "#2E2E2E"
                        }`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mr: 1,
                      }}
                    >
                      <Image
                        src={
                          plan?.name === "Starter"
                            ? starterImg
                            : plan?.name === "Private"
                            ? privateImg
                            : plan?.name === "Business"
                            ? businessImg
                            : enterpriseImg
                        }
                        alt="logo"
                        width={20}
                        height={20}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "18px",
                        fontWeight: "500",
                        color: mode === "light" ? "black" : "#fff",
                      }}
                    >
                      {plan?.name || "N/A"}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                      color: mode === "light" ? "black" : "#fff",
                    }}
                  >
                    $
                    {billingCycle === "Yearly"
                      ? billingCycleAmount / 12
                      : billingCycleAmount || "N/A"}
                    <span style={{ fontSize: "12px" }}> /monthly</span>
                  </Typography>
                </Box>

                {/* Details Section */}
                <Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                      Organization URL
                    </Typography>
                    <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                      {email}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                      Per user
                    </Typography>
                    <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                      {noOfUsers}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                      Billing Cycle
                    </Typography>
                    <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                      {billingCycle}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ backgroundColor: "#5C5C5C", my: 2 }} />

                {/* Price Summary Section */}
                {/* <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: mode === "light" ? "black" : "#FFFFFF",
                    mb: 2,
                  }}
                >
                  Price Summary
                </Typography> */}
                {/* <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={1}
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    Subscription for 15 users
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    $150.00
                  </Typography>
                </Box> */}
                {/* <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={1}
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    8% VAT
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    $12
                  </Typography>
                </Box> */}
                {/* <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    City Tax
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#A5A5A5" }}>
                    $16.85
                  </Typography>
                </Box> */}

                {/* <Divider sx={{ backgroundColor: "#5C5C5C", my: 2 }} /> */}

                {/* Total Price Section */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                      color: mode === "light" ? "black" : "#FFFFFF",
                    }}
                  >
                    {billingCycle === "Yearly" ? "Yearly" : "Monthly"} Total
                  </Typography>
                  <Box sx={{ mt: "1rem" }}>
                    <Typography
                      sx={{
                        fontSize: "25px",
                        color: mode === "light" ? "black" : "#FFFFFF",
                      }}
                    >
                      ${totalAmount}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "12px",
                        textAlign: "right",
                        color: "#A5A5A5",
                      }}
                    >
                      (excluding tax)
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "#A5A5A5",
                    textAlign: "center",
                    mt: "1rem",
                  }}
                >
                  You won’t be charged until {nextBillingDate}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ConfirmSubscription;
